import React from 'react';
// Analytics
import { usePageTracking } from '../../hooks/useAnalytics';
// Components
import Navbar from '../../components/nav/Navbar';
import FooterComponent from '../../components/footer/FooterComponent';
import AboutPageMainContainer from '../../components/about/AboutPageMainContainer';
import { HelmetItem } from '../../components/utils/HelmetItem';
import AboutPageHeader from '../../components/about/AboutPageHeader';
// Constants
import { CompanyName } from '../../utils/Constants';
// Data
import {
  aboutPageAdditionalMeta,
  aboutPageStructuredData,
} from '../../utils/data/MetaData';

const AboutPage = React.memo(() => {
  usePageTracking();

  return (
    <>
      <HelmetItem
        PageName="About"
        desc={`${CompanyName} — learn more about Siv Renate’s journey, her work in commercials and UGC creation, and her dedication to helping clients through wellness coaching.`}
        keywords={`Siv Renate, ${CompanyName}, about Siv Renate, commercials, UGC creator, wellness coaching, mental wellness, Drammen Norway`}
        additionalMeta={aboutPageAdditionalMeta}
        structuredData={aboutPageStructuredData}
      />

      {/* Page */}
      <div className="grid min-h-screen overflow-hidden bg-colour1 text-colour2 dark:bg-colour2 dark:text-colour1 font-poppins">
        <div className="grid">
          {/* Navigation + header */}
          <div className="grid relative grid-rows-reg min-h-screen h-screen max-h-screen">
            <Navbar />
            <AboutPageHeader />
          </div>

          {/* Main page content */}
          <AboutPageMainContainer />

          {/* Footer */}
          <FooterComponent />
        </div>
      </div>
    </>
  );
});

export default AboutPage;
